import { __extends } from "tslib";
import * as React from 'react';
import AddIcon from 'wix-ui-icons-common/Add';
import * as css from './AddItem.scss';
import { translate } from 'react-i18next';
import { TextButton } from 'wix-style-react';
var AddItem = /** @class */ (function (_super) {
    __extends(AddItem, _super);
    function AddItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddItem.prototype.render = function () {
        var _a = this.props, children = _a.children, dataHook = _a.dataHook, onClick = _a.onClick;
        return (React.createElement("div", { className: css.addItemView, onClick: onClick },
            React.createElement(TextButton, { prefixIcon: React.createElement(AddIcon, null), size: "medium", dataHook: dataHook }, children)));
    };
    return AddItem;
}(React.PureComponent));
export default translate()(AddItem);
//# sourceMappingURL=AddItem.js.map